import { getProfileRequest } from "api/auth";
import Loader from "components/shared/loader";
import PopoverProvider from "providers/PopoverProvider";
import PopupProvider from "providers/PopupProvider";
import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import { setSkinConfig } from "store/componentsSlice";
import { useAppDispatch } from "store/hooks";
import { getSkinConfigByUnivers } from "styles/skin";
import { getAppUrl } from "utils/defines";
import { getLocalStorageAccessToken } from "utils/helpers/localStorage";
import { useAuth } from "utils/hooks/useAuth";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";

const RootRoute: React.FC = () => {
  const { isAuth, setIsAuth, setProfile } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const loginProcess = location.pathname.startsWith("/wso/callback");

  const { network, isLoading, brand } = useSalesNetwork();

  const dispatch = useAppDispatch();

  useEffect(() => {
    //todo review after changig routes
    const onPopState = (e: PopStateEvent) => {
      if ((window as any).IsInFormPage && (window as any).wasInSolutionsPage) {
        const state = e.state;
        const href = window.location.pathname + window.location.search;
        const cb = () => {
          window.removeEventListener("popstate", cb);
          setTimeout(() => navigate(href, { state }), 0);
        };
        window.addEventListener("popstate", cb);
        navigate(-1);
      }
      (window as any).wasInSolutionsPage = false;
    };
    window.addEventListener("popstate", onPopState);
    return () => {
      window.removeEventListener("popstate", onPopState);
    };
  }, []);

  useEffect(() => {
    const token = getLocalStorageAccessToken();

    if (token) {
      setIsAuth(true);
      return;
    }

    if (
      !network ||
      isLoading ||
      location.pathname.endsWith("/template") ||
      loginProcess
    ) {
      return;
    }

    if (
      location.pathname != getAppUrl("/") &&
      !isAuth
    ) {
      navigate(getAppUrl("/"));
    }
  }, [
    isAuth,
    isLoading,
    location.pathname,
    loginProcess,
    navigate,
    network,
    setIsAuth,
  ]);

  useEffect(() => {
    if (isAuth) {
      getProfileRequest().then((res) => {
        setProfile(res.data);
        setIsAuth(true);
      });
    }
  }, [isAuth, setProfile]);



  useEffect(() => {
    
      dispatch(setSkinConfig(getSkinConfigByUnivers(brand || "")));
  }, [dispatch, brand]);

  return network ? (
      <PopoverProvider>
        <PopupProvider>
          <Outlet />
        </PopupProvider>
      </PopoverProvider>
  ) : (
    <>
      <Loader />
      <Outlet />
    </>
  );
};

export default RootRoute;
